module.exports = __webpack_public_path__ + "img/BBB-logo.6a25f500.png";